import { render, staticRenderFns } from "./UpShopHouseDetail.vue?vue&type=template&id=d55d18b8&scoped=true"
import script from "./UpShopHouseDetail.vue?vue&type=script&lang=js"
export * from "./UpShopHouseDetail.vue?vue&type=script&lang=js"
import style0 from "./UpShopHouseDetail.vue?vue&type=style&index=0&id=d55d18b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55d18b8",
  null
  
)

export default component.exports